export default "__VITE_ASSET__9bfe1d30__"